module.exports = new __parcel__URL__("96217_sq.4453717e.jpg").toString();